import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'css-loader/lib/css-base'
import 'vue-style-loader/lib/addStylesShadow'
import 'vue-loader/lib/runtime/componentNormalizer'

import vue2Verify from '~root/src/components/Slide.vue?shadow'
window.customElements.define('vue2-verify', wrap(Vue, vue2Verify))